import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "../pages/Home/HomePage";
import NotFoundPage from "../pages/NotFoundPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rute-rute resmi Anda */}
        <Route path="/" element={<HomePage />} />

        {/* TRICK: Taruh ini di paling bawah untuk menangkap semua rute salah */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
